//
//
//
//
//
//
//
//
//
//
//
//

import mgForm from '../custom/mg-form/mgForm.vue';
import mgFormItem from '../custom/mg-form/mgFormItem.vue';
import mgFormInput from '../custom/mgFormInput.vue';
import mgText from '../custom/mgText.vue';

const isEmailOrIsPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$|\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/; // 邮箱或手机号

export default {
  name: 'contact-form',
  components: {
    mgForm,
    mgFormItem,
    mgFormInput,
    mgText,
  },
  props: {
    visible: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      formData: {
        contact: '',
        content: '',
      },
      rules: {
        content: [
          { required: true, message: '不能为空', trigger: 'blur' },
          {
            type: 'string',
            length: 300,
          },
        ],
        contact: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { pattern: isEmailOrIsPhone, message: '邮箱或手机号格式不正确', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    handleSubmit(option) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          option.success(this.formData);
        } else {
          option.fail();
        }
      });
    },
    handleReset() {
      this.formData = {
        contact: '',
        content: '',
      };
      this.$refs.form.resetFields();
    },
  },
};
